module.exports = __webpack_public_path__ + "static/little-nomad.ac8c1a83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/little-nomad.png
// module id = 477
// module chunks = 35783957827783